import http from "../http/http-config";
import { GoodTypes } from "../models/goodTypes";

export default new class GoodTypesService {
    getGoodTypes(productId, securityGroup, onDate, correlationInformation, userName, userToken, tokenType): Promise<GoodTypes[]> {
        return http.get<GoodTypes[]>("GoodTypes", {
            params: {
                productId,
                securityGroup,
                onDate,
                correlationInformation,
                userName,
                userToken,
                tokenType
            }
        }).then(response => response.data)
    }
}